<template>
    <div class="modal fade" id="organizacao_competencia_demandas_create_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Nova</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            <div class="alert alert-danger" v-if="errors.length > 0">
                                <ul>
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Competência:</label>
                                <input type="number" v-model="organizacao_competencia_demandas.competencia" class="form-control">
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="createCompetencia">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../../app';
    import Dot from '../../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                organizacao: {},
                organizacao_competencia_demandas: {
                    competencia: '',
                    organizacao_id: null
                }
            }
        },

        mounted(){
        	this.registryEventOpenModalCreateCompetenciaDemandaOrganizacao();
        },

        methods: {
            registryEventOpenModalCreateCompetenciaDemandaOrganizacao(){
                eventBus.$on('eventOpenModalCreateCompetenciaDemandaOrganizacao', (organizacaoParam) => {
                	this.errors = [];
                    this.resetForm();
                    this.organizacao = Object.assign({}, organizacaoParam);
                    $("#organizacao_competencia_demandas_create_modal").modal("show");
                });
            },

            emitEventGetCompetenciasDemandaOrganizacao(){
                eventBus.$emit('eventGetCompetenciasDemandaOrganizacao');
            },

            resetForm()
            {
                this.errors = [];
                this.organizacao_competencia_demandas = {
                    competencia: (new Date()).getFullYear(),
                    organizacao_id: null
                }
            },

            checkForm:function() {
                this.errors = [];

                if(this.organizacao_competencia_demandas.competencia &&
                    this.organizacao_competencia_demandas.organizacao_id
                ) {
                    return true;
                }
                
                if(!this.organizacao_competencia_demandas.competencia) this.errors.push("Informe a competência");
                if(!this.organizacao_competencia_demandas.organizacao_id) this.errors.push("Informe o organização");
            },

            createCompetencia()
            {
                this.organizacao_competencia_demandas.organizacao_id = this.organizacao.id;
                if(this.checkForm()){
                    this.isLoading = true;
                    axios.post('/organizacao/competenciademanda', this.organizacao_competencia_demandas).then(response => {
                        this.isLoading = false;
                        $("#organizacao_competencia_demandas_create_modal").modal("hide");
                        toastr.success(response.data.message);
                        this.emitEventGetCompetenciasDemandaOrganizacao();
                    })
                    .catch(error => {
                        let me = this;
                        this.isLoading = false;
                        let erroObject = error.response.data;
                        this.errors = [];
                        if( error.response.status === 422 ){
                            if (erroObject.errors) {
                                $.each(erroObject.errors, function (key, value) {
                                    me.errors.push(value[0]);
                                });
                            }
                        }
                        else {
                            toastr.error(erroObject.message);
                        }
                    });
                }
            },
        }
    }
</script>